import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  selectProfile,
  selectProfileStatus,
  selectProfileError,
  fetchUserProfile,
} from "../redux/slices/profileSlice";
import { useEffect, useState } from "react";

function Footer() {
  const dispatch = useDispatch();
  const profile = useSelector(selectProfile);
  const status = useSelector(selectProfileStatus);
  const error = useSelector(selectProfileError);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (status === "idle" && !profile) {
      dispatch(fetchUserProfile());
    }
  }, [dispatch, status, profile]);

  return (
    <>
      <section>
        <div className="container mt-6">
          <div className="bg-success p-lg-5 p-5 rounded-top-4">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <h5 class="mb-0 fs-4 fw-normal lh-sm text-light text-uppercase">
                    Refer your friend / family and earn more
                  </h5>
                  <h4 class="h2 text-white fw-normal ls-sm lh-1">
                    Trusted By{" "}
                    <span className="fw-bold">
                      1 Lakh<i className="bi bi-plus me-1"></i>
                    </span>{" "}
                    Users
                  </h4>
                  <div className="mt-n4 pt-2">
                    <img
                      src="/assets/images/line-shap.webp"
                      width="230"
                      className="mt-2"
                    />
                  </div>
                </div>
                <div className="col-lg-4 d-flex justify-content-end align-items-center mt-lg-0 mt-4">
                  <span
                    onClick={() => {
                      navigator.clipboard.writeText(
                        `${window.location.origin}/sign-up?referral=${profile?.userId}`,
                      );

                      setCopied(true);

                      setTimeout(() => {
                        setCopied(false);
                      }, 2000);
                    }}
                    className="btn btn-light btn-md px-7 rounded-pill"
                  >
                    <i
                      className={`bi ${copied ? "bi-check-circle" : "bi-copy"} me-2`}
                    ></i>
                    {copied ? "Link Copied" : "Share Referral Code"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer class="footer footer-bg pt-6 pb-2">
        <div class="container">
          <div class="row gy-6 gy-xl-0 pb-4">
            <div class="col-xl-5 col-lg-12 col-md-6 col-12">
              <div class="d-flex flex-column gap-4 pe-5">
                <h1 className="display-6 fw-bold ls-sm lh-1">
                  <span className="text-white fw-light">
                    Welcome to Khayat Group
                  </span>
                </h1>
                <div className="mt-n5">
                  <img src="/assets/images/line-shap.webp" width="150" />
                </div>
                <p class="mb-0 lh-sm text-white">
                  Your Gateway to Smart Shopping & Smart Earning
                  <br />
                  <br />
                  Khayat Group is a fast-growing FMCG-based network marketing
                  company that combines daily essential products with a
                  reward-driven earning system. We empower individuals to build
                  a sustainable income while enjoying premium-quality products
                  for their everyday needs.
                  <br />
                  <br />
                  At Khayat Group, we offer a wide range of Fast-Moving Consumer
                  Goods (FMCG) including:
                  <br />
                  <ul className="mt-3 ps-3">
                    <li>Health & Nutrition Products</li>
                    <li>Personal Care Essentials</li>
                    <li>Home & Hygiene Solutions</li>
                    <li>Daily Grocery & Lifestyle Products</li>
                  </ul>
                </p>
              </div>
            </div>
            <div class="col-xl-2 col-md-3 col-6">
              <div class="d-flex flex-column gap-3">
                <span class="text-white-stable fw-medium text-light">
                  Community
                </span>
                <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                  <li>
                    <Link to="/dashboard" class="nav-link">
                      Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link to="products" class="nav-link">
                      Our Products
                    </Link>
                  </li>
                  <li>
                    <Link to="/network" class="nav-link">
                      Referral Network / History
                    </Link>
                  </li>
                  <li>
                    <Link to="/orders" class="nav-link">
                      Order History
                    </Link>
                  </li>
                  <li>
                    <Link to="/notifications" class="nav-link">
                      Notifications
                    </Link>
                  </li>
                  <li>
                    <Link to="/wallet" class="nav-link">
                      Wallet History
                    </Link>
                  </li>
                  <li>
                    <Link to="/cart" class="nav-link">
                      Your Shopping Cart
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-2 col-md-3 col-12">
              <div class="d-flex flex-column gap-3">
                <span class="text-white-stable fw-medium text-light">
                  Company
                </span>
                <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                  <li>
                    <Link to="/" class="nav-link">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <a href="#" class="nav-link">
                      Terms & Conditions
                    </a>
                  </li>
                  <li>
                    <a href="#" class="nav-link">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="#" class="nav-link">
                      Payment Policy
                    </a>
                  </li>
                  <li>
                    <a href="#" class="nav-link">
                      Shipping Policy
                    </a>
                  </li>
                  <li>
                    <a href="#" class="nav-link">
                      Cancellation Policy
                    </a>
                  </li>
                  <li>
                    <Link to="/" class="nav-link">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-12">
              <div class="d-flex flex-column gap-5">
                <div class="d-flex flex-column gap-3">
                  <span class="text-white-stable fw-medium text-light">
                    Contact Khayat Group
                  </span>
                  <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                    <li className="mb-1">
                      Toll free: <span class="fw-normal">+91 8877665544</span>
                    </li>
                    <li className="mb-1">
                      Email: <span class="fw-normal">info@khayatgroup.com</span>
                    </li>
                    <li className="lh-sm mb-1">
                      Address: <span class="fw-normal">Kerela, IN</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-5">
          <h4 className="text-white lh-sm mb-0 fw-normal">
            Join the Khayat Group Community
          </h4>
          <p className="text-white mt-2 lh-sm">
            Turn your everyday purchases into a powerful income opportunity.
            <br />
            Build your network, grow through levels, and enjoy the journey
            toward financial freedom with Khayat Group.
          </p>
        </div>
      </footer>

      <div className="container mb-lg-2 mb-8 pb-lg-0 pb-5">
        <div class="bg-black py-3 rounded-4 rounded-top-0">
          <div className="container">
            <div class="text-center">
              <span className="fw-normal m-0 text-light lh-sm">
                Copyright © 2026 Khayat Group
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
